import React from 'react';
import CrudPage from '../../components/CrudPage';
import { propertiesTypeApi } from '../../services/adminApi';

const columns = [
  { header: 'ID', field: 'propertyTypeId' },
  { header: 'Type Name', field: 'propertyTypeName' },
];

const formFields = [
  { name: 'propertyTypeName', label: 'Type Name', type: 'text', required: true },
];

const PropertiesTypePage = () => (
  <CrudPage
    title="Property Types"
    subtitle="Manage property types"
    api={propertiesTypeApi}
    columns={columns}
    formFields={formFields}
    idField="propertyTypeId"
    searchField="propertyTypeName"
  />
);

export default PropertiesTypePage;
